import { useGetClaimType } from '../../screens/Claims/OverCharge/hooks/select-options/use-get-claim-type';
import FormSelectBox from '../Inputs/FormSelectBox';

const OverChargeClaimTypeSelector = ({
  placeholder = 'Select Type',
  label = 'Type',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  disableValidation = false,
}) => {
  const { data: options = [], isLoading } = useGetClaimType();

  const prefixFilterOption = (input, option) => {
    const inputValue = String(input || '')
      .toLowerCase()
      .trim();
    const optionLabel = String(option?.children || '').toLowerCase();
    return optionLabel.startsWith(inputValue);
  };

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      filterOption={prefixFilterOption}
      optionFilterProp="children"
    />
  );
};

export default OverChargeClaimTypeSelector;
